/**
 * API configuration for backend services
 */

import { getTokenMakerUrl } from "../utils";

export const API_CONFIG = {
  endpoints: {
    compressImage: "/api/ramp-images/compress",
  },
} as const;

/**
 * Get the full URL for the image compression endpoint
 */
export function getCompressionUrl(): string {
  return `${getTokenMakerUrl()}${API_CONFIG.endpoints.compressImage}`;
}
